import { REDIRECT } from "@/imports-files/common/common";
export const ADMIN = 'Administrator';

export const CLIENT_ROLES = {
                              CLIENT_ADMIN:  "client_admin",
                              ACCOUNT_OWNER: "account_owner",
                              CLIENT_USER:  "client_user",
                              REVIEWER: "reviewer",
                            }

export const AGENCIES_ROLES = {
                                AGENCY_ADMIN:  "admin",
                                AGENCY_USER:  "user",
                              }

export const SIDEBAR_OPTIONS = (t) => {
  var isTranslation = (typeof t === 'function')

  return [{
  activities: {
    link: '/clients/activities',
    active: false,
    subsidebar_status: 'close',
    title: isTranslation ? t('sidebar:activities:title') : "View Activity",
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER, CLIENT_ROLES.REVIEWER],
    subSidebar_options: {
                              // "add_teams":{
                              //               link: `${REDIRECT.client.quick_setup}add_teams`,
                              //               title:'Add Teams',
                              //               step: 0,
                              //               allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER]
                              //             },
                              "company_integrations" :{
                                                          link: `${REDIRECT.client.quick_setup}company_integrations`,
                                                          title: isTranslation ? t('sidebar:activities:options:company_integrations') : 'Company Integrations',
                                                          step: 1,
                                                          allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                                                      },
                              'careers_page':{
                                                link: `${REDIRECT.client.quick_setup}careers_page`,
                                                title: isTranslation ? t('sidebar:activities:options:careers_page') : 'Career Page',
                                                step: 2,
                                                allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ]
                                            },
                              'job_adverts':{
                                  link: `${REDIRECT.client.quick_setup}job_adverts`,
                                  title: isTranslation ? t('sidebar:branding:options:job_advert_settings') : 'Job Advert Settings',
                                  step: 3,
                                  allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                              },
                              'email_branding':{
                                  link: `${REDIRECT.client.quick_setup}email_branding`,
                                  title: isTranslation ?  t('sidebar:branding:options:email_branding') :  "Email Branding",
                                  step: 4,
                                  allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                              },
                              'privacy_policy':{
                                  link: `${REDIRECT.client.quick_setup}privacy_policy`,
                                  title: isTranslation ? t('sidebar:activities:options:privacy_policy') : 'Privacy Policy',
                                  step: 3,
                                  allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                              },
                              'my_account':{
                                                link: `${REDIRECT.client.quick_setup}my_account`,
                                                title: isTranslation ? t('sidebar:activities:options:my_account') : 'My Account',
                                                step: 4,
                                                allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                            },
                              'my_integrations':{
                                                link: `${REDIRECT.client.quick_setup}my_integrations`,
                                                title: isTranslation ? t('sidebar:activities:options:my_integrations') : 'My Integrations',
                                                step: 5,
                                                allowed_user_type:  [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                            },
                              'my_preferences':{
                                                    link: `${REDIRECT.client.quick_setup}my_preferences`,
                                                    title: isTranslation ? t('sidebar:activities:options:my_preferences') : 'My Preferences',
                                                    step: 6,
                                                    allowed_user_type:  [CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                                }
                          },
  },
  communication: {
    link: REDIRECT.client.communication.inbox,
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, CLIENT_ROLES.CLIENT_USER],
    subSidebar_options:{
                          'inbox':{
                                       link: REDIRECT.client.communication.inbox,
                                         title: isTranslation ? t('sidebar:communication:options:inbox') : 'Inbox'
                                  },
                          'sent':{
                                   link: REDIRECT.client.communication.sent,
                                    title: isTranslation ? t('sidebar:communication:options:sent') : 'Sent'
                                 },

                      },
                      title: isTranslation ? t('sidebar:communication:title') : 'Communication',
  },
  jobs: {
    link: '/clients/jobs?job_type=active',
    active: false,
    subsidebar_status: 'close',
    subSidebar_options: {
                            'job-details'     : {
                                                    link: REDIRECT.client.jobs.edit,
                                                    title: isTranslation ? t('sidebar:jobs:options:job_details') : 'Job Details',
                                                    step: 0
                                                },
                            'job-options'     : {
                                                    link: REDIRECT.client.jobs.job_options,
                                                    title: isTranslation ? t('sidebar:jobs:options:job_options') : 'Job Options',
                                                    step: 1
                                                },
                            'interview-stages': {
                                                    link: REDIRECT.client.jobs.interview_stages,
                                                    title: isTranslation ? t('sidebar:jobs:options:interview_stages') : 'Interview Stages',
                                                    step: 2
                                                },
                            'interview-details'      : {
                                                    link: REDIRECT.client.jobs.interview_details,
                                                    title: isTranslation ? t('sidebar:jobs:options:interview_details') : 'Interview Details',
                                                    step: 3
                                                },
                            'scorecards'      : {
                                                    link: REDIRECT.client.jobs.scorecards,
                                                    title: isTranslation ? t('sidebar:jobs:options:scorecards') : 'Scorecards',
                                                    step: 4
                                                },
                            'job-sharing'     : {
                                                    link: REDIRECT.client.jobs.job_sharing,
                                                    title: isTranslation ? t('sidebar:jobs:options:job_sharing') : 'Sharing',
                                                    step: 5
                                                }
                        },
    title: isTranslation ? t('sidebar:jobs:title') : 'Jobs',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,   CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
  },
  candidates: {
    link: '/clients/candidates',
    active: false,
    subsidebar_status: 'close',
    subSidebar_options: null,
    title: isTranslation ? t('sidebar:candidates:title') : 'Candidates',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER]
  },

  reports: {
     link: REDIRECT.client.reports.interview_by_stages,
     active: false,
     subsidebar_status: 'close',
     type: 'menu',
     title: isTranslation ? t('sidebar:reports:title') : 'Reports',
     allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER],
     subSidebar_options: {
                            'current_pipeline':{
                                                      link:  REDIRECT.client.reports.interview_by_stages,
                                                      title: isTranslation ? t('sidebar:reports:options:current_pipeline') : 'Current Pipeline',
                                                      allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                                                  },
                            'pipeline_speed':{
                                link:  REDIRECT.client.reports.pipeline_speed,
                                title: isTranslation ? t('sidebar:reports:options:pipeline_speed') : 'Pipeline Speed',
                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                            },
                            'pipeline_conversion':{
                                link:  REDIRECT.client.reports.pipeline_conversion,
                                title: isTranslation ? t('sidebar:reports:options:pipeline_conversion') : 'Pipeline Conversion',
                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                            },
                            'time-to-hire':{
                                                link: REDIRECT.client.reports.time_to_hire,
                                                title: isTranslation ? t('sidebar:reports:options:time_to_hire') : 'Time To Hire',
                                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER],
                                           },
                           
                            'source':{
                                              link:  REDIRECT.client.reports.source+'?date_choice=all_time',
                                              title: isTranslation ? t('sidebar:reports:options:source') : 'Source of Candidates',
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER],
                                     },
                            'total-jobs-live-overtime':{
                                                            link:  REDIRECT.client.reports.total_jobs_live_overtime,
                                                            title: isTranslation ? t('sidebar:reports:options:jobs_over_time') : 'Jobs over time',
                                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                                                      },
                            'live-jobs-by-age':{
                                                     link:  REDIRECT.client.reports.live_jobs_by_age,
                                                     title: isTranslation ? t('sidebar:reports:options:live_jobs_by_age') : 'Live Jobs By Age',
                                                     allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                                               },
                            'report-gdpr':{
                                            link: REDIRECT.client.reports.gdpr,
                                            title: isTranslation ? t('sidebar:reports:options:gdpr') : 'GDPR',
                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN],
                                      },
                            // 'in-process':{
                            //                         link: REDIRECT.client.reports.in_process,
                            //                         title: 'In Process',
                            //                         allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER],
                            //               },

                          }
   },
  settings: {
    link: '/settings',
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,   CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
    subSidebar_options: {
                            'personal':{
                                          link: '',
                                          title: isTranslation ? t('sidebar:settings:options:personal:title') : 'Personal',
                                          allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER],
                                          subSidebar_options:{
                                                                'my-account':{
                                                                                  link:  REDIRECT.client.settings.personal.my_account,
                                                                                   title: isTranslation ? t('sidebar:settings:options:personal:options:my_account') : 'My Account'
                                                                            },
                                                                'notification-setting':{
                                                                                        link: '/clients/notification-setting?type=email',
                                                                                       title: isTranslation ? t('sidebar:settings:options:personal:options:my_notifications') : 'My Notifications'
                                                                                      },
                                                                'my-preferences':{
                                                                                    link: REDIRECT.client.my_preferences,
                                                                                    title: isTranslation ? t('sidebar:settings:options:personal:options:my_preferences') : 'My Preferences'
                                                                                }

                                                              }
                                       },
                            'company':{
                                          link: '',
                                          title: isTranslation ? t('sidebar:settings:options:company:title') : 'Company',
                                          allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,  CLIENT_ROLES.CLIENT_USER,  ADMIN],
                                          subSidebar_options:{

                                            'company-profile':{
                                                                link: REDIRECT.client.company.company_profile,
                                                               title: isTranslation ? t('sidebar:settings:options:company:options:profile') : 'Profile',
                                                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN]
                                                              },
                                            'add-team':{
                                                        link: REDIRECT.client.company.add_team,
                                                        title: isTranslation ? t('sidebar:settings:options:company:options:team') : 'Team',
                                                        allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN]
                                                      },
                                            'agencies':{
                                              link: REDIRECT.client.company.agencies,
                                              title: isTranslation ? t('sidebar:settings:options:company:options:agencies') : 'Agencies',
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER]
                                            }
                                          }
                                      },
                            'integrations': {
                                              link: '',
                                              title: isTranslation ? t('sidebar:settings:options:integrations:title') : 'Integrations',
                                              subSidebar_options:{
                                                                      'my-integration':{
                                                                                        link: REDIRECT.client.my_integrations,
                                                                                        title: isTranslation ? t('sidebar:settings:options:integrations:options:my_integration') : 'My Integrations',
                                                                                        allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                                                                      },
                                                                      'company-integrations':{
                                                                                                link: REDIRECT.client.company_integrations,
                                                                                                title: isTranslation ? t('sidebar:settings:options:integrations:options:company_integrations') : 'Company Integrations',
                                                                                                allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                                                                                            },
                                                                      'jobs-api':{
                                                                                  link:REDIRECT.client.jobs_api,
                                                                                  title: isTranslation ? t('sidebar:settings:options:integrations:options:jobs_api') : 'Jobs API',
                                                                                  allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                                                                                }
                                                                  },
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER,   ADMIN,  CLIENT_ROLES.CLIENT_USER,  CLIENT_ROLES.REVIEWER]
                                            },
                            'branding':{
                                            link: '',
                                            title: isTranslation ? t('sidebar:branding:title') : 'Branding',
                                            subSidebar_options:{
                                                                    'career-page-settings':{
                                                                                  link: REDIRECT.client.branding.career_page_settings,
                                                                                  title: isTranslation ? t('sidebar:branding:options:career_page_settings') : 'Career Page Settings'
                                                                               },
                                                                    'edit-career-page':{
                                                                                   link: REDIRECT.client.branding.edit_career_page,
                                                                                   title: isTranslation ? t('sidebar:branding:options:edit_career_page') : 'Edit Career Page'
                                                                                },
                                                                    'job-adverts': {
                                                                                  link: REDIRECT.client.branding.job_adverts,
                                                                                  title: isTranslation ? t('sidebar:branding:options:job_adverts') : 'Job Adverts'
                                                                    },
                                                                    'email-branding': {
                                                                      link: REDIRECT.client.branding.email_branding,
                                                                      title: isTranslation ? t('sidebar:branding:options:email_branding') : 'Email Branding',
                                                                    },
                                                               },
                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ]
                                          },
                            'recruitment':{
                                            link: '',
                                            title: isTranslation ? t('sidebar:settings:options:recruitment:title') : 'Recruitment',
                                            allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN,  CLIENT_ROLES.ACCOUNT_OWNER, ADMIN, CLIENT_ROLES.CLIENT_USER],
                                            subSidebar_options:{
                                                                  'scorecard-templates':{
                                                                                link: REDIRECT.client.recruitment.scorecard_templates,
                                                                                  title: isTranslation ? t('sidebar:settings:options:recruitment:options:scorecard_templates') : 'Scorecard Templates'
                                                                        },
                                                                  'email-templates':{
                                                                                link: REDIRECT.client.recruitment.email_templates,
                                                                                title: isTranslation ? t('sidebar:settings:options:recruitment:options:email_templates') : 'Email Templates'
                                                                        },
                                                                  'calendar-invites':{
                                                                          link: REDIRECT.client.recruitment.calendar_invites,
                                                                           title: isTranslation ? t('sidebar:settings:options:recruitment:options:calendar_invites') : 'Calendar Invites'
                                                                        },
                                                                  'unsuccessful-reasons':{
                                                                                link: REDIRECT.client.recruitment.unsuccessful_reasons,
                                                                                 title: isTranslation ? t('sidebar:settings:options:recruitment:options:unsuccessful_reasons') : 'Unsuccessful Reasons'
                                                                              },
                                                                   'manage-assessment':{
                                                                                link: REDIRECT.client.recruitment.manage_assessment,
                                                                                title: isTranslation ? t('sidebar:settings:options:recruitment:options:manage_assessment') : 'Manage Assessments'
                                                                              },
                                                                    'contract-templates':{
                                                                      link: REDIRECT.client.recruitment.contract_templates,
                                                                      title: isTranslation ? t('sidebar:settings:options:recruitment:options:contract_templates') : 'Contract Templates'
                                                                    }
                                                                }
                                          },
                            'data-privacy':{
                                              link: '',
                                             title: isTranslation ? t('sidebar:settings:options:data_privacy:title') : 'Data & Privacy',
                                              allowed_user_type: [CLIENT_ROLES.CLIENT_ADMIN, CLIENT_ROLES.ACCOUNT_OWNER, ],
                                              subSidebar_options:{
                                                'privacy-policy':{
                                                              link: REDIRECT.client.settings.data_privacy.privacy_policy,
                                                              title: isTranslation ? t('sidebar:settings:options:data_privacy:options:privacy_policy') : 'Privacy Policy'
                                                            },
                                                'gdpr':{
                                                      link: REDIRECT.client.settings.data_privacy.gdpr,
                                                      title: isTranslation ? t('sidebar:reports:options:gdpr') : 'GDPR',
                                                    },
                                                }
                                            }
                        },
     title: isTranslation ? t('sidebar:settings:title') : 'Settings'
  }
}]} ;


export const ADMIN_SIDEBAR_OPTIONS = (t) => {
  var isTranslation = (typeof t === 'function')

  return [{
  activities: {
    link: '/admins/activities/activity',
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    options: null,
    title: isTranslation ? t('sidebar:admin:view_activity') : 'View Activity',
    allowed_user_type: [ADMIN]
  },
  clients: {
    link: REDIRECT.admins.dashboard.clients.client,
    active: false,
    subsidebar_status: 'close',
    type: 'steps',
    allowed_user_type: [ADMIN],
    subSidebar_options: {
                            "company":{
                                         link: REDIRECT.admins.dashboard.clients.edit,
                                         title:'Company',
                                         step: 0
                                      },
                            // "add-users" :{
                            //             link: REDIRECT.admins.dashboard.clients.users,
                            //             title:'Users',
                            //             step: 1
                            //         },
                            'integrations':{
                                              link: REDIRECT.admins.dashboard.clients.integration,
                                              title:'Integrations',
                                              step: 2
                                           }
                        },
    title: isTranslation ? t('sidebar:admin:clients') : 'Clients'
  },
  users: {
    link: '/admins/users',
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title: isTranslation ? t('sidebar:admin:users') : 'Users',
    allowed_user_type: [ADMIN]
  }

}]};


export const AGENCY_SIDEBAR_OPTIONS  = (t) => {
  var isTranslation = (typeof t === 'function')

  return [{
  activities: {
    link: REDIRECT.agency.dashboard.activities,
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title: isTranslation ? t('sidebar:agency:activity') : 'Activity',
    allowed_user_type: [AGENCIES_ROLES.AGENCY_USER, AGENCIES_ROLES.AGENCY_ADMIN ],
  },
  jobs: {
    link: REDIRECT.agency.dashboard.jobs,
    active: false,
    subsidebar_status: 'close',
    type: 'menu',
    subSidebar_options: null,
    title: isTranslation ? t('sidebar:agency:jobs') : 'Jobs',
    allowed_user_type: [AGENCIES_ROLES.AGENCY_USER, AGENCIES_ROLES.AGENCY_ADMIN ],
  },
  users: {
     link: REDIRECT.agency.dashboard.users,
     active: false,
     subsidebar_status: 'close',
     type: 'menu',
    subSidebar_options: null,
     title: isTranslation ? t('sidebar:agency:users') : 'Users',
     allowed_user_type: [AGENCIES_ROLES.AGENCY_ADMIN]
    },
  settings: {
     link: REDIRECT.agency.dashboard.profile,
     active: false,
     subsidebar_status: 'close',
     type: 'menu',
     subSidebar_options: null,
     title: isTranslation ? t('sidebar:agency:profile') : 'Agencies Profiles',
     allowed_user_type: [AGENCIES_ROLES.AGENCY_ADMIN]
   }
}]
} ;
